import {type ReactNode} from 'react';

import {FG_TERTIARY, NEUTRAL_20} from '../../constants';

export function SettingGroup(props: {title: string; isLast?: boolean; children: ReactNode}) {
  return (
    <div
      style={{
        padding: '14px 16px 6px',
        borderBottom: props.isLast ? 'none' : `1px solid ${NEUTRAL_20}`,
      }}
    >
      <div
        style={{
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: FG_TERTIARY,
          marginBottom: '12px',
        }}
      >
        {props.title}
      </div>
      {props.children}
    </div>
  );
}
